/* eslint-disable @typescript-eslint/no-explicit-any */
import { LoanApplicationOfferResponse, PayloadRequestColoneApplication, PayloadRequestPatchOffer } from "@interfaces/MarketPlace";
import { baseApi } from "./baseApi";

const marketPlaceApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    patchOferSelected: build.mutation<any, { id_sol: string; id_offer: string; data: PayloadRequestPatchOffer }>({
      query: ({ id_sol, id_offer, data }) => ({
        url: `solicitudes/${id_sol}/ofertas/${id_offer}`,
        method: "PATCH",
        body: data,
      }),
    }),
    getOffers: build.query<LoanApplicationOfferResponse[], { id_sol: string }>({
      query: ({ id_sol }) => `solicitudes/${id_sol}/ofertas`,
      transformResponse: (response: {
        code: string;
        message: string;
        errors: any[];
        data: {
          page: number;
          size: number;
          total: number;
          total_pages: number;
          data: LoanApplicationOfferResponse[];
        };
      }) => {
        return response.data?.data || [];
      },
    }),
    postCloneApplication: build.mutation<
      any,
      { application_id: string; data: PayloadRequestColoneApplication; accessToken?: string }
    >({
      query: ({ application_id, data, accessToken }) => ({
        url: `solicitudes/${application_id }/transfer`,
        method: "POST",
        body: data,
        headers: accessToken ? { authorization: `Bearer ${accessToken}` } : undefined,
      }),
    }),
  }),
});

export const { usePatchOferSelectedMutation, useLazyGetOffersQuery, usePostCloneApplicationMutation } = marketPlaceApi;
